import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { BaseService } from 'src/app/services/common/base.service';
import { shareReplay} from 'rxjs/operators';

@Component({
  selector: 'app-drill-down-rejected-report',
  templateUrl: './drill-down-rejected-report.component.html',
  styleUrls: ['./drill-down-rejected-report.component.scss']
})
export class DrillDownRejectedReportComponent implements OnInit {

  @Input() drilldownDetails: any;
  drillDownData:any;
  drillDownDataStatus=false;
  appVerificationItems_dialog: MenuItem[];
  exportColumns: { title: string; dataKey: string; }[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  constructor(private reportsService:ReportsService 
    ,private messageService:MessageService
    ,private router: Router
    ,private dashboard: DashboardService
    ,private activityRecordService: ActivityRecordService
    ,private loader: AppLoaderService
    ,private cryptoJs: CryptoJsService
    ,private service: BaseService
    ,private cryptoJsService: CryptoJsService) { }
    userId:any;
    isComponentId:boolean;
    isArea:boolean;
    totalArea:number;
    arrayIndex:number;
    grandTotalArea:number;
  tempVendorWise: any[];
  ngOnInit(): void {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    this.userId = userId;
    this.userId=encodeURIComponent(this.cryptoJs.Encrypt(this.userId))
    // console.log(this.drilldownDetails,"drilldownDetailsdrilldownDetailsdrilldownDetailsdrilldownDetails")
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems_dialog = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.drillDownData, "Drill_down_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.drillDownData, "Drill_down_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }
  loadData(selectedYear:any){
    
    // this.loader.start();
    this.loading = true;
    this.drillDownDataStatus=true;
    if(this.drilldownDetails.hasOwnProperty('Block')){
      let sub= this.reportsService.getRejectedApplication_Block_DrillDown_Report(this.drilldownDetails.actionType,this.userId,this.drilldownDetails.filterType,this.drilldownDetails.MIType,this.drilldownDetails.value,this.drilldownDetails.Block,selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
             // this.loader.close();
           this.loading = false;
            data.forEach(e=>{
              if(e.hasOwnProperty('years')){
                e.Years=e.years
               }
               if(e.hasOwnProperty('componentId')){
                this.isComponentId=true;
               }
               if(e.hasOwnProperty('Area')){
                this.isArea=true;
               }
              e.Assigned_Date=new Date(e.Assigned_Date)
              e.Assigned_Date_filter=e.Assigned_Date.toString().substr(4,11)
              e.Action_Date=new Date(e.Action_Date)
              e.Action_Date_filter=e.Action_Date.toString().substr(4,11)
            })
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.drillDownData = data;
              this.drillDownDataStatus=true;
             
            }
            else{
              
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.drillDownDataStatus=false;
            }
          },
          error: (err) => {
             // this.loader.close();
           this.loading = false;
           this.drillDownDataStatus=false;
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
    }
    else{
      if(this.drilldownDetails.actionType=='AppVerification' && this.drilldownDetails.MIType.length==0 ) {
        let sub=this.reportsService.getAppVerificationRejectedApplication_DrillDown_Report(this.drilldownDetails.actionType,this.userId,this.drilldownDetails.filterType,this.drilldownDetails.MIType,this.drilldownDetails.value,selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            data.forEach(e=>{
              if(e.hasOwnProperty('years')){
                e.Years=e.years
               }
               if(e.hasOwnProperty('componentId')){
                this.isComponentId=true;
               }
               if(e.hasOwnProperty('Area')){
                this.isArea=true;
               }
              e.Assigned_Date=new Date(e.Assigned_Date)
              e.Assigned_Date_filter=e.Assigned_Date.toString().substr(4,11)
              e.Action_Date=new Date(e.Action_Date)
              e.Action_Date_filter=e.Action_Date.toString().substr(4,11)
              // console.log( e.Action_Date_filter," e.Action_Date_filter")
            })
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.drillDownData = data;
              this.drillDownDataStatus=true;
             
            }
            else{
              
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.drillDownDataStatus=false;
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.drillDownDataStatus=false;
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
      }
      else{
        if(this.drilldownDetails.actionType=='VendorMIArea'){
          let sub=this.reportsService.getVendor_MI_Area_Report(this.userId,this.drilldownDetails.status,this.drilldownDetails.MIType,this.drilldownDetails.value,selectedYear)
          .pipe(first())
          .subscribe({
            next: (data) => {
               // this.loader.close();
           this.loading = false;
              data.forEach(e=>{
                if(e.hasOwnProperty('years')){
                  e.Years=e.years
                 }
                 if(e.hasOwnProperty('componentId')){
                  this.isComponentId=true;
                 }
                 if(e.hasOwnProperty('Area')){
                  this.isArea=true;
                 }
                e.Assigned_Date=new Date(e.Assigned_Date)
                e.Assigned_Date_filter=e.Assigned_Date.toString().substr(4,11)
                e.Action_Date=new Date(e.Action_Date)
                e.Action_Date_filter=e.Action_Date.toString().substr(4,11)
              })
              // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');
  
              // console.log("dataaa", data)
              if (data?.length > 0) {
                this.drillDownData = data;
                this.drillDownDataStatus=true;
                this.tempVendorWise=this.drillDownData;
                this.arrayIndex=0;
                this.calculateGrandTotal();
                this.calculateTotalApp()
               
              }
              else{
              
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
                this.drillDownDataStatus=false;
              }
            },
            error: (err) => {
              // this.loader.close();
           this.loading = false;
           this.drillDownDataStatus=false;
              // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);
  
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
  
            }
          });
          this.subscriptions.push(sub);
        }
        else{
          let sub= this.reportsService.getRejectedApplication_DrillDown_Report(this.drilldownDetails.actionType,this.userId,this.drilldownDetails.filterType,this.drilldownDetails.MIType,this.drilldownDetails.value,selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
             // this.loader.close();
           this.loading = false;
            data.forEach(e=>{
              if(e.hasOwnProperty('years')){
                e.Years=e.years
               }
               if(e.hasOwnProperty('componentId')){
                this.isComponentId=true;
               }
               if(e.hasOwnProperty('Area')){
                this.isArea=true;
               }
              e.Assigned_Date=new Date(e.Assigned_Date)
              e.Assigned_Date_filter=e.Assigned_Date.toString().substr(4,11)
              e.Action_Date=new Date(e.Action_Date)
              e.Action_Date_filter=e.Action_Date.toString().substr(4,11)
              // console.log( e.Action_Date_filter," e.Action_Date_filter")
            })
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.drillDownData = data;
              this.drillDownDataStatus=true;
              this.tempVendorWise=this.drillDownData;
              this.arrayIndex=0;
              this.calculateGrandTotal();
              this.calculateTotalApp()
             
            }
            else{
              
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.drillDownDataStatus=false;
            }
          },
          error: (err) => {
             // this.loader.close();
           this.loading = false;
           this.drillDownDataStatus=false;
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
        }       
      }
      
    }
    
  }
  
  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        
        if(this.drilldownDetails.actionType=='AppVerification'){
          return {
            'AppId':d.AppId,
          'Action':d.ActionId,
          'Level Id':d.Level_Id, 
          'UserId':d.UserId,
          'Status':d.Status,
          'Action Date':d.Action_Date_filter,
          'District':d.District,
          'Months':d.Months,
          'Years':d.Years,
          }
        }
        else{
          return {
            'AppId':d.AppId,
          'Action':d.ActionId,
          'Level Id':d.Level_Id, 
          'UserId':d.UserId,
          'Status':d.Status,
          'Action Date':d.Action_Date_filter,
          'component ':d.componentId,
          'District':d.District,
          'Months':d.Months,
          'Years':d.Years,
          'Area':d.Area
          }
        }
        
        
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'AppId', header: 'AppId'},
      { field: 'ActionId', header: 'Action' },
      { field: 'Level_Id', header: 'Level_Id' },
      { field: 'UserId', header: 'UserId' },
      { field: 'Status', header: 'Status' },
      // { field: 'Assigned_Date_filter', header: 'Assigned Date' },
      { field: 'Action_Date_filter', header: 'Action Date' },
      { field: 'componentId', header: 'component' },
      { field: 'District', header: 'District' },
      { field: 'Months', header: 'Months' },
      { field: 'Years', header: 'Year' },
      { field: 'Area', header: 'Area' },

     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempVendorWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalArea=0;
        for(let i=this.arrayIndex ;this.tempVendorWise.length>10?i<this.arrayIndex+10:i<this.tempVendorWise.length;i++) {
          //console.log( this.totalApp,"totalAPPPPPPPPP")
          this.totalArea +=this.tempVendorWise[i].Area;
          

        }      
    }
  calculateGrandTotal(){
    this.grandTotalArea=0;
    
    for(let districtWiseData of this.drillDownData) {
      this.grandTotalArea += districtWiseData.Area;
      
  }
  }  


}
